<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="pa-2">
        <v-card elevation="8">
          <div class="pt-4 pl-4 pr-4">
            <router-link to="/addsupplier">
              <v-btn class="grad-success-bg white--text" style="width: 100%;height: 45px">เพิ่มซัพพลายเออร์</v-btn>
            </router-link>
          </div>
          <div class="pa-2">
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="supplierHeaders" :items="supplierList" :footer-props="footer_Props"  :search="search" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div v-if="dataDetail.item.department != null">{{ dataDetail.item.department }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.name != null">{{ dataDetail.item.name }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.name_eng != null">{{ dataDetail.item.name_eng }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.note != null">{{ dataDetail.item.note }}</div>
                    <div v-else>-</div>
                  </td>
                  <!--                                    <td><v-switch color="#8cc63e" v-model="dataDetail.item.status"></v-switch></td>-->
                  <td class="pa-3">
                    <v-btn small height="42" @click="getDetails(dataDetail.item.id)" class="grad-success-bg white--text mr-1 mb-1" title="ดูรายละเอียด">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                      <v-icon>mdi-note-edit-outline</v-icon>
                    </v-btn>
                    <v-btn small height="42" @click="delAlert(dataDetail.item.id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <!-- modal -->
          <v-dialog v-model="modal_details" max-width="900">
            <div v-if="loading_modal === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-card>
                <v-form ref="add_form" @submit.prevent="">
                  <div class="pa-4 text-center">
                    รายละเอียด
                  </div>
                  <v-card-text>
                    <div>
                      <div class="grid_half">
                        <div class="mt-3 mr-1">
                          <div class="ml-2">รหัสซัพพลายเออร์ : {{ details_morg.supplier_code }}</div>
                        </div>
                        <div class="mt-3 mr-1" v-if="details_morg.supplier_type == 1">
                          <div class="d-flex">
                            <div class="ml-1">ประเภท : บุคคลธรรมดา</div>
                          </div>
                        </div>
                        <div class="mt-3 mr-1" v-if="details_morg.supplier_type == 2">
                          <div class="d-flex">
                            <div class="ml-1">ประเภท : นิติบุคคล</div>
                          </div>
                        </div>
                      </div>
                      <div class="grid_half">
                        <div class="mt-3 mr-1">
                          <div class="ma-2">ชื่อแผนก</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.department !== null || details_morg.department !== ''">{{ details_morg.department }}</div>
                          <div v-else class="ml-3 mt-3 mb-1 text_modal">-</div>
                        </div>

                        <div class="mt-3 mr-1">
                          <div class="ma-2">อีเมล</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.email != null">{{ details_morg.email }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                      </div>
                      <div class="grid_full">
                        <div class="mt-3 mr-1 grid_flex">
                          <div class="ma-2">ชื่อย่อ</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-if="details_morg.short_name != null">{{ details_morg.short_name }}</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1 grid_flex">
                          <div class="ma-2">ชื่อ (ไทย)</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-if="details_morg.name != null">{{ details_morg.name }}</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1 grid_flex">
                          <div class="ma-2">ชื่อ (อังกฤษ)</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-if="details_morg.name_eng != null">{{ details_morg.name_eng }}</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1 grid_flex">
                          <div class="ma-2">เลขเสียภาษี</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-if="details_morg.tax_number != null">{{ details_morg.tax_number }}</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1 grid_flex" v-if="details_morg.supplier_type == 2">
                          <div class="ma-2">เครดิต</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-if="details_morg.credit != null">{{ details_morg.credit }}</div>
                          <div class="ml-3 mt-2 mb-1 text_modal" v-else>0</div>
                        </div>
                      </div>
                      <v-divider class="ma-2"/>
                      <div class="pa-4 text-center">
                        ข้อมูลผู้ติดต่อ
                      </div>
                      <div class="four_grid">
                        <div class="mt-3 mr-1">
                          <div class="ma-2">ชื่อ - สกุล</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.name_contact != null">{{ details_morg.name_contact }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1">
                          <div class="ma-2">เบอร์โทร</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.telephone_contact != null">{{ details_morg.telephone_contact }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1">
                          <div class="ma-2">เงื่อนไขการหมดอายุ</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.expiration != null">{{ details_morg.expiration }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>ไม่มี</div>
                        </div>
                        <div class="mt-3 mr-1">
                          <div class="ma-2">เงื่อนไขเครดิต</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.credit_type != null">{{ details_morg.credit_type }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>ไม่มี</div>
                        </div>
                      </div>
                      <div class="grid_full">
                        <div class="mt-3">
                          <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.address != null">{{ details_morg.address }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                      </div>
                      <div class="four_grid">
                        <div class="mt-3 mr-1">
                          <div class="ma-2">ตำบล/แขวง</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.sub_district != null">{{ details_morg.sub_district }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1">
                          <div class="ma-2">อำเภอ/เขต</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.district != null">{{ details_morg.district }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1">
                          <div class="ma-2">จังหวัด</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.province != null">{{ details_morg.province }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                        <div class="mt-3 mr-1">
                          <div class="ma-2">รหัสไปรษณีย์</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.postcode != null">{{ details_morg.postcode }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                      </div>
                      <div class="grid_full">
                        <div class="mt-3 mr-1">
                          <div class="ma-2">หมายเหตุ</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-if="details_morg.note != null">{{ details_morg.note }}</div>
                          <div class="ml-3 mt-3 mb-1 text_modal" v-else>-</div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <div class="text-center pa-4">
                    <v-btn large class="grad-danger-bg white--text btn_mobile" type="button" style="font-size: 18px" @click="modal_details = false">
                      ปิด
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </div>
          </v-dialog>
          <v-dialog v-model="modal_edit" max-width="900">
            <div v-if="loading_modal === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-card>
                <v-form ref="update_form" @submit.prevent="updateSupplier">
                  <v-card-title>
                    แก้ไขรายละเอียด
                  </v-card-title>

                  <v-card-text>
                    <div>
                      <div class="grid_half">
                        <div class="mt-3 mr-1">
                          <div class="d-flex">
                            <v-icon>mdi-account</v-icon>
                            <div class="ml-1">รหัสซัพพลายเออร์ : {{ details_morg.supplier_code }}</div>
                          </div>
                        </div>
                        <div class="mt-n2">
                          <v-radio-group v-model="details_morg.supplier_type">
                            <div class="d-flex justify-center">
                              <div class="d-flex mr-1">
                                <div>
                                  <v-radio color="#86bc3a" :value="1"></v-radio>
                                </div>
                                <div>บุคคลธรรมดา</div>
                              </div>
                              <div class="d-flex ml-6">
                                <div>
                                  <v-radio color="#86bc3a" :value="2"></v-radio>
                                </div>
                                <div>นิติบุคคล</div>
                              </div>
                            </div>
                          </v-radio-group>
                        </div>
                      </div>
                      <div class="grid_half mt-n3">
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" label="ชื่อแผนก" prepend-inner-icon="mdi-account-outline"  hide-details="auto" v-model="details_morg.department" outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" type="email" label="อีเมล" @paste="isPaste($event)" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline" hide-details="auto" v-model="details_morg.email" outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" label="ชื่อ (ไทย)" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อ (ไทย)']" hide-details="auto" v-model="details_morg.name" required outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" label="ชื่อ (อังกฤษ)" prepend-inner-icon="mdi-account-outline"  hide-details="auto" v-model="details_morg.name_eng" outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" label="ชื่อย่อ" prepend-inner-icon="mdi-account-outline"  hide-details="auto" v-model="details_morg.short_name" outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" type="tel" label="เลขเสียภาษี" maxlength="13" @keypress="isTaxNumber($event, details_morg.tax_number)" prepend-inner-icon="mdi-account-outline" hide-details="auto" v-model="details_morg.tax_number" outlined></v-text-field>
                        </div>
                      </div>
                      <div class="mt-3 mr-1">
                        <div class="d-flex">
                          <v-icon>mdi-home</v-icon>
                          <div class="ml-1">ที่อยู่</div>
                        </div>
                      </div>
                      <div class="grid_full">
                        <div class="mt-3">
                          <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                          <v-text-field class="mt-3 mr-1" color="#86bc3a" placeholder="ที่อยู่" hide-details="auto" v-model="details_morg.address" outlined></v-text-field>
                        </div>
                      </div>
                      <div class="grid_half">
                        <div class="mt-3 mr-1">
                          <addressinput-subdistrict class="custom_css" placeholder="ตำบล/แขวง" v-model="details_morg.sub_district"/>
                        </div>
                        <div class="mt-3 mr-1">
                          <addressinput-district class="custom_css" placeholder="อำเภอ/เขต" v-model="details_morg.district"/>
                        </div>
                        <div class="mt-3 mr-1">
                          <addressinput-province class="custom_css" placeholder="จังหวัด" v-model="details_morg.province" />
                        </div>
                        <div class="mt-3 mr-1">
                          <addressinput-zipcode numbered class="custom_css" placeholder="รหัสไปรษณีย์" v-model="details_morg.postcode" />
                        </div>
                      </div>
                      <div class="grid_half">
                        <div class="mt-3 mr-1">
                          <div class="mt-2 mb-2">เงื่อนไขการรับคืนสินค้าหมดอายุ</div>
                          <v-select color="#86bc3a"  :items="filteredItems" item-text="name" item-value="id" v-model="details_morg.expiration" prepend-inner-icon="mdi-alarm" label="เงื่อนไขการหมดอายุ"  hide-details="auto" outlined></v-select>
                        </div>
                        <div class="mt-3 mr-1">
                          <div class="mt-2 mb-2">เงื่อนไขเครดิต</div>
                          <v-select color="#86bc3a" :items="items_credit" item-text="name" item-value="id" v-model="details_morg.credit_type" prepend-inner-icon="mdi-credit-card" label="เงื่อนไขเครดิต"  hide-details="auto" outlined></v-select>
                        </div>
                      </div>
                      <div class="grid_full">
                        <div class="mt-3 mr-1">
                          <div class="mt-2 mb-2">หมายเหตุ</div>
                          <v-text-field color="#86bc3a" label="หมายเหตุ" prepend-inner-icon="mdi-message-bulleted" hide-details="auto" v-model="details_morg.note" outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1" v-if="details_morg.supplier_type == 2">
                          <div class="mt-2 mb-2">เครดิต</div>
                          <v-text-field color="#86bc3a" label="เครดิต" type="number" @keypress="isCurrency($event, details_morg.credit)" prepend-inner-icon="mdi-credit-card" hide-details="auto" v-model="details_morg.credit" outlined></v-text-field>
                        </div>
                      </div>
                      <div class="d-flex mt-4">
                        <v-icon>mdi-account</v-icon>
                        <div class="ml-1">ข้อมูลผู้ติดต่อ</div>
                      </div>
                      <div class="grid_half">
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline" hide-details="auto" v-model="details_morg.name_contact" outlined></v-text-field>
                        </div>
                        <div class="mt-3 mr-1">
                          <v-text-field color="#86bc3a" type="tel" label="เบอร์โทร" maxlength="10" @keypress="isNumber($event, details_morg.telephone_contact)" prepend-inner-icon="mdi-phone-outline" hide-details="auto" v-model="details_morg.telephone_contact" outlined></v-text-field>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <div class="text-center pa-4">
                    <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                      แก้ไข
                    </v-btn>
                    <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px" @click="modal_edit = false">
                      ยกเลิก
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </div>
          </v-dialog>
          <!-- modal -->
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { HTTP } from '@/axios.js'
import {isTelephone, onlyForCurrency, onPaste, taxNumber, validateEmail} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "SupplierAdd",
  data() {
    return {
      loading_page: false,
      search: null,
      modal_details: false,
      loading_modal: false,
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      taxRules: [v => ( v.length === 13 ) || "เลขเสียภาษีไม่ถูกต้อง !",],
      item_page: -1,
      items: [
        {id: 0, name: 'ไม่มี'},
        {id: 3, name: '3 เดือน'},
        {id: 1, name: '6 เดือน'},
        {id: 2, name: '7 เดือน'},
        {id: 8, name: '8 เดือน'},
        {id: 4, name: '9 เดือน'},
        {id: 5, name: '10 เดือน'},
        {id: 6, name: '11 เดือน'},
        {id: 7, name: '12 เดือน'},
        {id: 9, name: '1 เดือน'},
        {id: 10, name: '2 เดือน'},
        {id: 11, name: '4 เดือน'},
      ],
      items_credit: [
        {id: 0, name: 'ไม่มี'},
        {id: 9, name: '30 วัน'},
        {id: 10, name: '60 วัน'},
        {id: 3, name: '90 วัน'},
        {id: 11, name: '120 วัน'},
        {id: 1, name: '180 วัน'},
      ],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      details_morg: {
        id: null,
        supplier_code: null,
        supplier_type: null,
        department: null,
        short_name: null,
        name: null,
        name_eng: null,
        tax_number: '',
        address: null,
        sub_district: null,
        district: null,
        province: null,
        postcode: null,
        email: '',
        note: null,
        expiration: null,
        credit_type: null,
        credit: '',
        name_contact: null,
        telephone_contact: '',
      },
      modal_edit: false,
      modal_delete: false,
      supplierHeaders: [
        {
          text: 'แผนก',
          value: 'department',
          fixed: true,
          width: '160px',
        },
        {
          text: 'ชื่อ (ไทย)',
          value: 'name',
          fixed: true,
          width: '255px',
        },
        {
          text: 'ชื่อ (อังกฤษ)',
          value: 'name_eng',
          fixed: true,
          width: '250px',
        },
        {
          text: 'หมายเหตุ',
          value: 'note',
          fixed: true,
          width: '230px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '200px',
        },
      ],
      supplierList: [],
    }
  },
  methods: {
    checkLoading() {
      this.loading_page = true
      HTTP.post('/suppliers/all')
          .then((res) => {
            if (res.data.success === true){
              this.loading_page = false
              this.supplierList = res.data.object;
            }
          })
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    createAlert() {
      Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
    },
    updateAlert() {
      Swal.fire('แก้ไขข้อมูลเรียบร้อย !', '', 'success')
          .then(() => {
            this.getSupplier()
          })
    },
    delAlert(id) {
      Swal.fire({
        title: 'คุณต้องลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
          this.getDelete(id)
        }
      });
    },
    getSupplier() {
      HTTP.post('/suppliers/all')
          .then((res) => {
            if (res.data.success === true){
              this.supplierList = res.data.object;
            }
          })
    },
    getDetails(id) {
      this.modal_details = true;
      this.loading_modal = true
      HTTP.post('/suppliers/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true){
          this.loading_modal = false
          this.details_morg.supplier_code = res.data.object.supplier_code;
          this.details_morg.supplier_type = res.data.object.supplier_type;
          this.details_morg.department = res.data.object.department;
          this.details_morg.short_name = res.data.object.short_name;
          this.details_morg.name = res.data.object.name;
          this.details_morg.name_eng = res.data.object.name_eng;
          this.details_morg.tax_number = res.data.object.tax_number;
          this.details_morg.address = res.data.object.address;
          this.details_morg.sub_district = res.data.object.sub_district;
          this.details_morg.district = res.data.object.district;
          this.details_morg.province = res.data.object.province;
          this.details_morg.postcode = res.data.object.postcode;
          this.details_morg.email = res.data.object.email;
          this.details_morg.note = res.data.object.note;
          if (res.data.object.expiration != null) {
            const exp = this.items.find((detail) => {
              return detail.id == res.data.object.expiration
            });
            this.details_morg.expiration = exp.name;
          }
          if (res.data.object.credits_condition != null) {
            const credit_condition = this.items.find((detail) => {
              return detail.id == res.data.object.credits_condition
            })
            
            this.details_morg.credit_type = credit_condition.name
          }else {
            this.details_morg.credit_type = null
          }
          this.details_morg.credit = res.data.object.credit;
          this.details_morg.name_contact = res.data.object.name_contact;
          this.details_morg.telephone_contact = res.data.object.telephone_contact;
        }
      });
    },
    getEdit(id) {
      this.modal_edit = true;
      this.loading_modal = true
      HTTP.post('/suppliers/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true){
          this.loading_modal = false
          this.details_morg.id = res.data.object.id;
          this.details_morg.supplier_code = res.data.object.supplier_code;
          this.details_morg.supplier_type = res.data.object.supplier_type;
          this.details_morg.department = res.data.object.department;
          this.details_morg.short_name = res.data.object.short_name;
          this.details_morg.name = res.data.object.name;
          this.details_morg.name_eng = res.data.object.name_eng;
          this.details_morg.tax_number = res.data.object.tax_number;
          this.details_morg.address = res.data.object.address;
          this.details_morg.sub_district = res.data.object.sub_district;
          this.details_morg.district = res.data.object.district;
          this.details_morg.province = res.data.object.province;
          this.details_morg.postcode = res.data.object.postcode;
          this.details_morg.email = res.data.object.email;
          this.details_morg.note = res.data.object.note;
          if (res.data.object.expiration != null) {
            const exp = this.items.find((detail) => {
              return detail.id == res.data.object.expiration
            });
            this.details_morg.expiration = exp.id;
          }
          if (res.data.object.credits_condition != null) {
            const credit_condition = this.items.find((detail) => {
              return detail.id == res.data.object.credits_condition
            })
            this.details_morg.credit_type = credit_condition.id
          }
          this.details_morg.credit = res.data.object.credit;
          this.details_morg.name_contact = res.data.object.name_contact;
          this.details_morg.telephone_contact = res.data.object.telephone_contact;
        }
      });
    },
    updateSupplier() {
      if (this.$refs.update_form.validate()) {
        HTTP.post('/suppliers/edit', {
          id: this.details_morg.id,
          supplier_code: this.details_morg.supplier_code,
          supplier_type: this.details_morg.supplier_type,
          department: this.details_morg.department,
          short_name: this.details_morg.short_name,
          name: this.details_morg.name,
          name_eng: this.details_morg.name_eng,
          tax_number: this.details_morg.tax_number,
          address: this.details_morg.address,
          sub_district: this.details_morg.sub_district,
          district: this.details_morg.district,
          province: this.details_morg.province,
          postcode: this.details_morg.postcode,
          email: this.details_morg.email,
          note: this.details_morg.note,
          credit: this.details_morg.credit,
          expiration: this.details_morg.expiration,
          credits_condition: this.details_morg.credit_type,
          name_contact: this.details_morg.name_contact,
          telephone_contact: this.details_morg.telephone_contact
        }).then((res) => {
          if (res.data.success === true){
            this.updateAlert()
            this.modal_edit = false
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    getDelete(id) {
      HTTP.post('/suppliers/delete', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
          this.getSupplier();
        }
      });
    },
  },
  beforeMount() {
    this.checkLoading();
  },
  computed: {
  filteredItems() {
    return this.items.filter(item => ![9, 10, 11].includes(item.id));
  }
}
}
</script>

<style scoped>
.text_modal {
  font-size: 18px;
  color: grey;
}
.custom_css >>> input {
  font-size: 18px;
  border-color: #9b9b9b;
  border-radius: 5px;
  padding: 16px;
  height: 56px !important;
}
.custom_css >>> input:hover {
  border-color: black;
}
.custom_css >>> input:focus {
  border-color: #8cc63e !important;
  border: solid 2px;
  padding: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_flex {
  display: flex;
}
.four_grid {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.btn_mobile{
  width: 30%;
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .four_grid {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
